module.exports = __webpack_public_path__ + "static/media/cc.a5ef984c.svg";